var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRedboxLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 289 71",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.1 48.4c1-4 4.5-6.3 8.6-6.3 4.6 0 7.8 2.1 8.4 6.3h-17Zm8.3-14.6c-10.5 0-18 7.4-18 18s8.3 18 20.5 18c5.4 0 10-1.2 12.8-3.2v-9.3h-.4a17 17 0 0 1-12 4.2c-5.9 0-10.2-2.6-11.2-7.3h25.7v-3.9c0-10.1-6.7-16.5-17.4-16.5ZM88.7 34.6c-4.2 0-7.2 1.4-9.2 4.3v-4.3h-9.6v34.5h9.6V53.6c.3-6.7 3-9.9 8.4-9.9 2.1 0 4 .6 5.4 1.6h.4v-9.4c-1-.8-2.8-1.3-5-1.3ZM232.6 61.3c-5.2 0-8.8-3.9-8.8-9.5s3.6-9.5 8.8-9.5c5.1 0 8.7 3.9 8.7 9.5s-3.6 9.5-8.7 9.5Zm0-27.5c-10.9 0-18.5 7.4-18.5 18 0 10.5 7.6 18 18.5 18 10.8 0 18.4-7.5 18.4-18 0-10.6-7.6-18-18.4-18Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m275.6 34.6-7 10.5-7.2-10.5h-11.6l12.4 16.7-13.1 17.8h11.2l7.7-11.6 7.8 11.6h11.6l-13-17.8 12.3-16.7h-11.1ZM151.9 61.3c-5.2 0-8.8-3.9-8.8-9.5s3.6-9.5 8.8-9.5c5.1 0 8.7 3.9 8.7 9.5.1 5.6-3.5 9.5-8.7 9.5Zm8.8-43.6v19.8h-.1a13.7 13.7 0 0 0-9.9-3.7c-9.8 0-16.9 7.6-16.9 18s7.1 18 16.9 18c4.3 0 7.7-1.4 10.1-3.9v3.2h9.6V17.7h-9.7ZM192.7 61.3c-5.1 0-8.7-3.9-8.7-9.5s3.6-9.5 8.7-9.5c5.2 0 8.8 3.9 8.8 9.5s-3.6 9.5-8.8 9.5Zm1.4-27.5c-4.3 0-7.6 1.3-9.9 3.7h-.1V17.7h-9.6v51.4h9.6v-3.2c2.3 2.5 5.7 3.9 10.1 3.9 9.8 0 16.9-7.6 16.9-18-.2-10.4-7.3-18-17-18ZM2.9 36.6c.5 17.7 14.8 32 32.5 32.5V36.6H2.9ZM37.4 2.1v32.5h32.5A33.7 33.7 0 0 0 37.4 2.1ZM35.4 2.1H2.9v32.5h32.5V2.1Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRedboxLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/redboxLogo.496e9e9a6b66cd27c81f340f25040c24.svg";